import { is } from 'superstruct';
import { EIP_712_TYPED_DATA_TYPE } from '../types';
export const validateTypedData = data => {
  return is(data, EIP_712_TYPED_DATA_TYPE);
};
//# sourceMappingURL=json.js.map